// removed by extract-text-webpack-plugin
module.exports = {"extraLarge":"size__extraLarge___3mHl1 fontSize-l","large":"size__large___1JdKh fontSize-m","medium":"size__medium___1q-Of fontSize-s","small":"size__small___1nqSI fontSize-xs","extraSmall":"size__extraSmall___1c0E- fontSize-xs"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/Button/style/size.css
// module id = 36
// module chunks = 0 2